import React from 'react'

import { Box, Button, Card, Heading, Inline, Modal, Stack, Textarea, Form } from '@myxplor/stardust'

import CloseIcon from '~/icons/Close'

interface Props {
  comment: string
  isOpen: boolean
  onSubmit(): void
  onChange(comment: string): void
  onCancel(): void
}

const ShiftCommentModal = ({ comment, isOpen, onSubmit, onChange, onCancel }: Props) => {
  return (
    <Modal isOpen={isOpen} onBlur={onCancel}>
      <Form onSubmit={onSubmit}>
        <Card data-qa="shift-comment-dialog">
          <Box width="440px" padding="large">
            <Box
              data-qa="shift-comment-close"
              color="lowEmphasis"
              padding="small"
              position="absolute"
              right={0}
              top={0}
              onClick={onCancel}>
              <CloseIcon />
            </Box>

            <Stack space="medium">
              <Heading data-qa="shift-comment-title" level={6}>
                Shift Comment
              </Heading>
              <Textarea
                data-qa="shift-comment-input"
                color="secondary"
                label="Write a comment about your shift"
                name="comment"
                value={comment}
                onChange={(value: string) => onChange(value)}
              />
              <Box width={1}>
                <Inline align="right" space="xsmall">
                  <Box data-qa="shift-comment-cancel">
                    <Button color="secondary" variant="outline" onClick={onCancel}>
                      Cancel
                    </Button>
                  </Box>
                  <Box data-qa="shift-comment-save">
                    <Button type="submit" color="secondary">
                      Save
                    </Button>
                  </Box>
                </Inline>
              </Box>
            </Stack>
          </Box>
        </Card>
      </Form>
    </Modal>
  )
}

export default React.memo(ShiftCommentModal)
